import request from "../../../helpers/request"

export const putAlertasReconhecer = async (id: string) => {
  if(!id) return null
  const url = `${process.env.REACT_APP_API}/Alerta/Reconhecer/${id}`
  const result =  await request({ url, method: "put" })
  return result.data
}